// src/components/selectors/TranslationModelSelector.js
import React from 'react';
import { Languages } from 'lucide-react'; // Using Languages icon for translation theme
import { AVAILABLE_TRANSLATION_MODELS, DEFAULT_TRANSLATION_MODEL } from '../constants/translationConfig';

const TranslationModelSelector = ({
  value,
  selectedTranslationModel,
  onChange,
  onTranslationModelChange,
  disabled = false
}) => {
  const selectedValue = value ?? selectedTranslationModel ?? DEFAULT_TRANSLATION_MODEL;
  const handleChange = onChange || onTranslationModelChange || (() => {});

  return (
    <div className="mb-2">
      <label className="block text-sm font-medium mb-1 flex items-center gap-2">
        <Languages className="w-4 h-4" />
        Translation Model
      </label>
      
      <select
        value={selectedValue}
        onChange={(e) => handleChange(e.target.value)}
        className="w-full p-2 border rounded bg-white"
        disabled={disabled}
      >
        {AVAILABLE_TRANSLATION_MODELS.map((model) => (
          <option key={model.value} value={model.value}>
            {model.label}
          </option>
        ))}
      </select>
      
      <p className="text-xs text-gray-500 mt-1">
        Select the AI model to use for translations. Different models may offer varying quality and cost.
      </p>
    </div>
  );
};

export default TranslationModelSelector;
